import { render, staticRenderFns } from "./closeToRequirements.vue?vue&type=template&id=6ff1f42e&"
import script from "./closeToRequirements.vue?vue&type=script&lang=js&"
export * from "./closeToRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports